import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { CheckIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { useCityStore, useFiltersStore, useMapViewStore } from '../stores';
import { CITY_OPTIONS, cityLabel, getInitMapViewStateForCity } from '../util/data-factory';

const CityFilter = () => {
  const { selectedCity, setSelectedCity } = useCityStore();
  const { clearCityScopedFilters } = useFiltersStore();
  const { setMainMapViewState, setListMapViewState } = useMapViewStore();

  const handleCityChange = city => {
    if (city === selectedCity) return;
    setSelectedCity(city);
    clearCityScopedFilters();

    const newMapViewState = getInitMapViewStateForCity(city);
    setMainMapViewState(newMapViewState);
    setListMapViewState({ ...newMapViewState, zoom: 12 });
  };

  return (
    <Menu as="div" className="relative mr-2">
      <Menu.Button
        className="flex items-center gap-1.5 rounded-full border border-black/20 bg-white px-4 py-2.5 text-sm font-semibold shadow-sm hover:bg-slate-50"
        aria-label={`City: ${selectedCity}. Change city`}
      >
        {cityLabel(selectedCity)}
        <ChevronDownIcon className="h-4 w-4 text-slate-600" />
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Menu.Items className="absolute left-0 z-[130] mt-2 w-56 origin-top-left rounded-2xl bg-white p-2 shadow-lg ring-1 ring-black/5 focus:outline-none">
          <p className="px-3 pb-2 pt-1 text-xs uppercase tracking-wider text-slate-400">
            Choose a city
          </p>
          {CITY_OPTIONS.map(option => {
            const isSelected = option.value === selectedCity;
            return (
              <Menu.Item key={option.value}>
                {({ active }) => (
                  <button
                    type="button"
                    onClick={() => handleCityChange(option.value)}
                    className={`flex w-full items-center justify-between rounded-full px-4 py-2.5 text-left ${
                      isSelected ? 'bg-black text-white' : active ? 'bg-slate-100' : ''
                    }`}
                  >
                    <span className="font-medium">{option.label}</span>
                    <span
                      className={`flex items-center gap-1 text-xs ${
                        isSelected ? 'text-white/80' : 'text-slate-500'
                      }`}
                    >
                      {option.value}
                      {isSelected && <CheckIcon className="h-4 w-4" />}
                    </span>
                  </button>
                )}
              </Menu.Item>
            );
          })}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default CityFilter;
